const MS_PER_HOUR = 60 * 60 * 1000;
const MS_PER_MINUTE = 60 * 1000;

export const formatDurationLabel = (
  durationMs: number | null,
  isNL?: boolean,
) => {
  if (durationMs === null || durationMs <= 0) {
    return null;
  }
  const hourPostfix = isNL ? 'u' : 'h';

  const hours = Math.floor(durationMs / MS_PER_HOUR);
  const minutes = Math.floor((durationMs % MS_PER_HOUR) / MS_PER_MINUTE);

  if (!hours) {
    return `${minutes}m`;
  }

  return !minutes
    ? `${hours}${hourPostfix}`
    : `${hours}${hourPostfix} ${minutes}m`;
};
